var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter filter-month"},[_c('el-date-picker',{attrs:{"type":"monthrange","range-separator":"--","start-placeholder":"Перший місяць","end-placeholder":"Останній місяць","size":"mini"},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }